export default "/images/banner1.jpg?34a280aee354823496c64af1ded4e765";